import type { ReactNode } from "react";

/**
 * Editorialer Klartext-Callout. Lime-Border-left, viel Weißraum, max-width 720px.
 * Dies sind die rhetorischen Höhepunkte einer Sektion — sie brauchen Luft.
 */
export function Callout({
  children,
  variant = "default",
}: {
  children: ReactNode;
  variant?: "default" | "deep";
}) {
  const text = variant === "deep" ? "text-white" : "text-ink";
  return (
    <blockquote className="my-14 max-w-[720px] border-l-4 border-lime pl-8">
      <p
        className={`font-display text-[clamp(20px,2.5vw,28px)] font-medium leading-[1.4] ${text}`}
      >
        {children}
      </p>
    </blockquote>
  );
}
